import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

/**
 * Mapa pathname → (title, subtitle) — centralizado para que la topbar
 * se sincronice con la navegación sin pasar props desde cada página.
 */
const PAGE_META: Record<string, { title: string; subtitle?: string }> = {
  '/':                { title: 'Dashboard',     subtitle: 'Resumen general del aplicativo' },
  '/mantenimiento':   { title: 'Mantenimiento', subtitle: 'Semáforo y ejecución de mantenimientos' },
  '/inventario':      { title: 'Inventario',    subtitle: 'Stock y ciclo de vida de activos' },
  '/accesos':         { title: 'Accesos',       subtitle: 'Movimientos registrados desde portería' },
  '/colaboradores':   { title: 'Colaboradores', subtitle: 'Directorio sincronizado con Google Workspace' },
  '/admin/usuarios':  { title: 'Usuarios',      subtitle: 'Gestión de cuentas del sistema' },
  '/admin/sync':      { title: 'Sincronización', subtitle: 'Forzar sync con GLPI y Google' },
  '/perfil':          { title: 'Mi perfil' },
  '/sin-permiso':     { title: 'Sin permiso' },
};

export function AppLayout() {
  const { pathname } = useLocation();
  const meta = PAGE_META[pathname] ?? { title: 'Aplicativo Soporte' };

  return (
    <div className="flex h-screen w-full bg-background">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar title={meta.title} subtitle={meta.subtitle} />
        <main className="flex-1 overflow-y-auto">
          <div className="container max-w-7xl mx-auto px-6 py-8 animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
